/**
 * The share link's token (GRO-83 design, "The `/share` page"), the invite link's pattern
 * (`members/inviteToken.ts`): it arrives in the fragment of `/share#<token>`, moves to
 * `sessionStorage` at once, and the fragment leaves the address bar. A reload of the same
 * tab keeps it until the open settles.
 */
const KEY = 'grovus.shareToken'
export const SHARE_PATH = '/share'

let memory: string | null = null

/** On `/share#<token>`: stores the token and replaces the URL with `/share`. */
export function captureShareToken() {
  if (window.location.pathname !== SHARE_PATH) return
  const token = window.location.hash.replace(/^#/, '')
  if (token === '') return
  try {
    sessionStorage.setItem(KEY, token)
  } catch {
    // No storage: the token is held in memory for this page only.
    memory = token
  }
  window.history.replaceState(null, '', SHARE_PATH)
}

export function heldShareToken(): string | null {
  try {
    return sessionStorage.getItem(KEY)
  } catch {
    return memory
  }
}

export function clearShareToken() {
  memory = null
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // Nothing stored.
  }
}
